import { Link } from 'react-router-dom'
import { Shield, BookOpen, Building2, MessageSquare, ArrowRight } from 'lucide-react'
import { useUser } from '../../contexts/UserContext'

const adminLinks = [
  {
    to: '/admin/approvals',
    title: 'Approvals',
    description: 'Review accounts and volunteer ID verifications',
    icon: Shield,
    color: 'from-primary-500 to-primary-600',
  },
  {
    to: '/admin/stories',
    title: 'Stories',
    description: 'Approve and manage blog posts',
    icon: BookOpen,
    color: 'from-secondary-500 to-secondary-600',
  },
  {
    to: '/admin/food-banks',
    title: 'Food banks',
    description: 'Food bank account approvals',
    icon: Building2,
    color: 'from-accent-500 to-accent-600',
  },
  {
    to: '/admin/feedback',
    title: 'Feedback',
    description: 'Read and respond to user feedback',
    icon: MessageSquare,
    color: 'from-neutral-600 to-neutral-700',
  },
]

const AdminDashboard = () => {
  const { user } = useUser()

  return (
    <div className="min-h-screen bg-gradient-to-br from-neutral-50 via-white to-primary-50/30 py-10">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100 text-primary-800 text-sm font-medium mb-4">
            <Shield className="h-4 w-4" />
            Admin
          </div>
          <h1 className="text-3xl font-bold text-neutral-900 tracking-tight">
            Welcome back{user?.firstName ? `, ${user.firstName}` : ''}
          </h1>
          <p className="text-neutral-600 mt-2">
            Manage approvals, content, and community feedback from one place.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
          {adminLinks.map(({ to, title, description, icon: Icon, color }) => (
            <Link
              key={to}
              to={to}
              className="group card-interactive flex flex-col p-6 bg-white"
            >
              <div
                className={`w-12 h-12 rounded-2xl bg-gradient-to-br ${color} flex items-center justify-center shadow-md mb-4 group-hover:scale-105 transition-transform`}
              >
                <Icon className="h-6 w-6 text-white" />
              </div>
              <h2 className="text-lg font-semibold text-neutral-900 mb-1">{title}</h2>
              <p className="text-sm text-neutral-600 flex-1">{description}</p>
              <span className="mt-4 inline-flex items-center text-sm font-medium text-primary-600 group-hover:text-primary-700">
                Open
                <ArrowRight className="ml-1 h-4 w-4 group-hover:translate-x-0.5 transition-transform" />
              </span>
            </Link>
          ))}
        </div>
      </div>
    </div>
  )
}

export default AdminDashboard
